interface LoadingScreenProps {
  /** Optional message below the spinner. Defaults to "Loading..." */
  message?: string;
}

/**
 * Full-screen loading indicator used during route transitions and auth checks.
 */
export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-4 animate-pulse">
          <span className="text-white font-bold text-2xl">PA</span>
        </div>
        <p className="text-slate-600">{message}</p>
      </div>
    </div>
  );
}
